import { Portion } from '../interfaces/menuInterfaces';
export const PRICE_FALLBACK = 'please enquire';

export const getDisplayPrice = (portions: Portion[]) => {
  if (!portions || !portions.length) {
    return PRICE_FALLBACK;
  } else if (portions.length === 1) {
    return portions[0].price ?? PRICE_FALLBACK;
  } else {
    // get lowest price
    return Math.min(...portions.map((portion) => portion.price));
  }
};
